import { Collection } from './collection';
import { IComponentEvent } from './types';
import { Observable, of } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { isTrue } from './utils';

export class EventsCore<AllowedEvents = any> {
  private readonly events$: Collection<IComponentEvent> = new Collection<IComponentEvent>({
    indexBy: 'type',
  });

  public emitEvent = (type: AllowedEvents, data: any = null): void => {
    const { events$ } = this;
    of(null)
      .pipe(
        take(1),
        tap(() => events$.add({ data, type })),
        tap(() => events$.remove(type))
      )
      .subscribe();
  };

  public onEvent = <T = any>(type: AllowedEvents, getFullEvent: boolean = false): Observable<T> => {
    const { events$ } = this;

    return events$.onChange().pipe(
      map(() => events$.getItem(type)),
      filter(isTrue),
      map((event: IComponentEvent) => (getFullEvent ? { ...event } : event.data))
    );
  };
}
